// src/padplanner/usePlanProjects.js
//
// The projects New plan and Edit details offer: GET /padplanner/projects,
// exactly the projects the API accepts on a plan. Until fix/tiles-and-projects
// the forms offered the project picker's list (useProjectStore), which merges
// PadRekko QC projects from other orgs on purpose, so a choice could be one
// the save refused.
//
// {projects: null} while loading; {projects: [], failed: true} when the read
// failed, so a form can say so rather than look like an org with no projects.

import { useEffect, useState } from "react";
import { listProjects } from "../api/padplannerApi";

export const PROJECTS_FAILED_TEXT = "Projects couldn't be loaded. The plan can still be saved without one.";

export function usePlanProjects() {
  const [state, setState] = useState({ projects: null, failed: false });
  useEffect(() => {
    let live = true;
    listProjects().then(
      (r) => { if (live) setState({ projects: Array.isArray(r?.projects) ? r.projects : [], failed: false }); },
      () => { if (live) setState({ projects: [], failed: true }); },
    );
    return () => { live = false; };
  }, []);
  return state;
}
